export type ParsedChoice = {key: string; label: string};

export type ParsedQuestion = {
  index: number;
  prompt: string;
  choices: ParsedChoice[];
  /** Stable id from clarification contract (v1); used in submitted answer lines. */
  questionId?: string;
};

export type ClarificationWizardState = {
  intro: string;
  questions: ParsedQuestion[];
};

/** Last choice label matches "other" — show a free-form field without an extra click. */
export function splitChoicesForUi(choices: ParsedChoice[]): {
  primary: ParsedChoice[];
  other?: ParsedChoice;
} {
  if (choices.length === 0) return {primary: []};
  const last = choices[choices.length - 1];
  if (/other|something else/i.test(last.label)) {
    return {primary: choices.slice(0, -1), other: last};
  }
  return {primary: choices, other: undefined};
}
